import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
const SettingsCtx = createContext(null);

export function AppProviders({ children }) {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState(null);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      try {
        await api.post("/auth/refresh");
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      }
    }
  }, []);

  const loadSettings = useCallback(async () => {
    try {
      const { data } = await api.get("/public/settings");
      setSettings(data);
      if (data.brand?.primary_color) document.documentElement.style.setProperty("--brand", data.brand.primary_color);
    } catch {
      setSettings({ brand: { name: "Conexão Litigium" }, texts: {}, business_services: { recorrente: [], pontual: [] }, stages: [], ufs: [] });
    }
  }, []);

  useEffect(() => {
    loadSettings();
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
    } else {
      refreshUser();
    }
    const onExpired = () => setUser(false);
    window.addEventListener("azv-session-expired", onExpired);
    return () => window.removeEventListener("azv-session-expired", onExpired);
  }, [loadSettings, refreshUser]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setUser(false);
    }
  };

  return (
    <SettingsCtx.Provider value={{ settings, reloadSettings: loadSettings }}>
      <AuthCtx.Provider value={{ user, setUser, refreshUser, logout }}>{children}</AuthCtx.Provider>
    </SettingsCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
export const useSettings = () => useContext(SettingsCtx);
